module.exports = __webpack_public_path__ + "media/images/smart_phone/kutikomi/btn_clap_ov-868af299abe23cd73732625a81c3aa56.png";